import type { ReactNode } from 'react';
import { cn } from '../../lib/utils';

type AlertVariant = 'success' | 'warning' | 'info' | 'error';

const variantStyles: Record<AlertVariant, string> = {
  success: 'border-success/20 bg-success/5 text-success',
  warning: 'border-warning/20 bg-warning/5 text-warning',
  info: 'border-primary/20 bg-primary/5 text-primary',
  error: 'border-error/20 bg-error/5 text-error',
};

interface AlertProps {
  variant: AlertVariant;
  children: ReactNode;
  className?: string;
  /** `alert` interrupts a screen reader; use it for an error the user has just caused. */
  role?: 'status' | 'alert';
}

export function Alert({ variant, children, className, role = 'status' }: AlertProps) {
  return (
    <div role={role} className={cn('rounded-lg border p-3 text-sm', variantStyles[variant], className)}>
      {children}
    </div>
  );
}
